// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".warning{color:red;margin-top:10px}", "",{"version":3,"sources":["webpack://./resources/assets/js/partials/Admin/VJSModals/DeleteStreamModal.vue"],"names":[],"mappings":"AAAA,SAAA,SAAA,CAAA,eAAA","sourcesContent":[".warning{color:red;margin-top:10px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
